import React from 'react';
import { useNutsAuth } from '../../context/NutsAuthContext';
import { NutsLanding } from './NutsLanding';
import { NutsDashboard } from './NutsDashboard';

/**
 * Smart wrapper for /nuts route.
 * Shows the public landing (with auth forms) when no session,
 * and the member dashboard when logged in.
 */
export const NutsPage = () => {
  const { member, loading } = useNutsAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-[#0E4D2A] flex items-center justify-center text-[#A8B4A6] font-sans tracking-widest text-sm">
        ...
      </div>
    );
  }

  return member ? <NutsDashboard /> : <NutsLanding />;
};

export default NutsPage;
